// core
import {Injectable} from '@angular/core';

// service
import {CustomHttp} from '../../core/http-custom/http-custom.service';

import {OverviewUserForCustomerManager} from "../../user/models/overview-user-customer-manager.model";
import {HttpParams} from "@angular/common/http";

@Injectable()
export class AdminUserOverviewService {

  constructor(private _http: CustomHttp) {
  }

  public loadUsers(httpParams: HttpParams) {
    return this._http.get<Array<OverviewUserForCustomerManager>>(
      '/apps/umng/user/me/employee',
      null,
      httpParams
    );
  }

}
